import { isIOS } from '../../core/util/device';

// These are from Apple
export const SOLV_APPLE_ID = 1464601606;
export const SOLV_APPLE_PROVIDER_ID = 120007617;

// Google specific constants
export const SOLV_GOOGLE_PLAY_ID = 'com.solv';

export const downloadDriverFeatureFlagCheck = () => {
  const flag = (typeof window === 'undefined' ? process.env : window.CFG).FF_DOWNLOAD_DRIVER;
  return typeof flag === 'string' ? flag === 'true' : flag;
};

export const getSolvAppStoreLink = (campaignName = 'generic-solv-website-campaign') =>
  `https://apps.apple.com/app/apple-store/id${SOLV_APPLE_ID}?pt=${SOLV_APPLE_PROVIDER_ID}&ct=${campaignName}&mt=8`;

export const getSolvPlayStoreLink = (campaignName = 'generic-solv-website-campaign') =>
  `https://play.google.com/store/apps/details?id=${SOLV_GOOGLE_PLAY_ID}&referrer=utm_source%3D${campaignName}%26utm_medium%3Ddownload_driver%26anid%3Dadmob`;

export const getNativeStoreDownloadLink = (campaignName = 'generic-solv-website-campaign') =>
  isIOS() ? getSolvAppStoreLink(campaignName) : getSolvPlayStoreLink(campaignName);
